export default __webpack_public_path__ + "static/media/alertIconGreen.a5faf289.svg";